import moment from 'moment-timezone';

import { getStateBackground, getEventBackground } from './getIconByValue';
import { STATE_CHART_ICON_MAPPING, EVENT_ICON_SIZE, EVENT_NAMES } from './constants';
import { StateDataType, EventDataType } from '../TimelineEvents/types';

export const convertStateDataToChart = (data: StateDataType[]) =>
  data.map((item: StateDataType) => ({
    name: item.value,
    value: [
      0,
      moment(item.startTimeMs).valueOf(),
      moment(item.endTimeMs).valueOf(),
      item.value,
    ],
    itemStyle: {
      normal: {
        color: STATE_CHART_ICON_MAPPING[item.value],
      },
    },
  }));

export const convertEventDataToChart = (
  data: EventDataType[],
  range: number,
  dateRange: number[],
) => {
  if (data.length === 0 || range === 0) {
    return [];
  }
  const rangeOverlay = dateRange.length > 1
    ? Math.ceil(EVENT_ICON_SIZE / range) * (dateRange[1] - dateRange[0])
    : Math.ceil(EVENT_ICON_SIZE / range);
  const { timeMs: startTime } = data[0];
  const { value } = data[0];
  const res = [{ value: [startTime, value, [{ value, time: startTime }]] }];
  for (let i = 1; i < data.length; i += 1) {
    const { timeMs, value: currentValue } = data[i];
    // If two icon has overlay, we need to change icon to be a special value(-1)
    const lastTime = res[res.length - 1].value[0];
    if ((timeMs - lastTime) <= rangeOverlay) {
      res[res.length - 1].value[1] = EVENT_NAMES.More;
      res[res.length - 1].value[2].push({ value: currentValue, time: timeMs });
    } else {
      res.push({ value: [timeMs, currentValue, [{ value: currentValue, time: timeMs }]] });
    }
  }
  return res;
};

export const renderStateItem = (params, api) => {
  const categoryIndex = api.value(0);
  const start = api.coord([api.value(1), categoryIndex]);
  const end = api.coord([api.value(2), categoryIndex]);
  const { height } = params.coordSys;

  let stateBackground = getStateBackground(api.value(3));

  // workaround for firefox CE-6892
  const width = Math.round(end[0] - start[0]);
  // if (/.*buffering.*/i.test(api.value(3))) {
  const correctSize = `width='${width}px' height='${height}px' viewBox='0 0 ${width} ${height}'`;
  stateBackground = stateBackground.replace('width=\'100px\' height=\'100px\' viewBox=\'0 0 100 100\'', correctSize);
  // }

  return {
    type: 'image',
    style: {
      image: stateBackground,
      x: start[0],
      y: start[1] - height,
      width,
      height,
    },
  };

};

export const renderEventItem = (params, api, startLimit, endLimit) => {
  const eventTime = api.value(0);
  const eventType = api.value(1);
  const [x] = api.coord([eventTime, 0]);

  if (eventTime < startLimit || eventTime > endLimit) {
    /**
     * Fix for https://conviva.atlassian.net/browse/CE-7281
     * previously we were returning null here
     * but after echarts upgrade to 5.x this started breaking on certain zooms.
     * Returning a rect with 0 width and height as a hacky solution.
     * There are rect markers against the events but do not get displayed if they are out of time range.
     */
    return {
      type: 'rect',
      shape: {
        x,
        y: 56,
        width: 0,
        height: 0,
      },
      style: {
        fill: '#979797',
      },
    };
  }

  const eventIcon = getEventBackground(eventType);

  if (eventIcon) {
    return (
      {
        type: 'group',
        children: [
          {
            type: 'rect',
            shape: {
              x,
              y: 56,
              width: 1,
              height: 12,
            },
            style: {
              fill: '#979797',
            },
          },
          {
            type: 'image',
            style: {
              image: eventIcon,
              x: x - 6,
              y: eventType === EVENT_NAMES.More ? 38 : 33,
              height: eventType === EVENT_NAMES.More ? 3 : EVENT_ICON_SIZE,
              width: EVENT_ICON_SIZE,
            },
          },
        ],
      }
    );
  } else {
    return {
      type: 'rect',
      shape: {
        x,
        y: 56,
        width: 0,
        height: 0,
      },
      style: {
        fill: '#979797',
      },
    };
  }
};
